/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APISimpleAddress } from './APISimpleAddress';
import {
    APISimpleAddressFromJSON,
    APISimpleAddressFromJSONTyped,
    APISimpleAddressToJSON,
} from './APISimpleAddress';
import type { APIRootAccount } from './APIRootAccount';
import {
    APIRootAccountFromJSON,
    APIRootAccountFromJSONTyped,
    APIRootAccountToJSON,
} from './APIRootAccount';

/**
 * 
 * @export
 * @interface APIOrganizationSearchResult
 */
export interface APIOrganizationSearchResult {
    /**
     * 
     * @type {string}
     * @memberof APIOrganizationSearchResult
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof APIOrganizationSearchResult
     */
    score: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIOrganizationSearchResult
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof APIOrganizationSearchResult
     */
    vatNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof APIOrganizationSearchResult
     */
    website?: string;
    /**
     * 
     * @type {APIRootAccount}
     * @memberof APIOrganizationSearchResult
     */
    rootAccount?: APIRootAccount | null;
    /**
     * 
     * @type {string}
     * @memberof APIOrganizationSearchResult
     */
    rootAccountId?: string | null;
    /**
     * 
     * @type {APISimpleAddress}
     * @memberof APIOrganizationSearchResult
     */
    billingAddress?: APISimpleAddress | null;
    /**
     * 
     * @type {APISimpleAddress}
     * @memberof APIOrganizationSearchResult
     */
    shippingAddress?: APISimpleAddress | null;
}

/**
 * Check if a given object implements the APIOrganizationSearchResult interface.
 */
export function instanceOfAPIOrganizationSearchResult(value: object): value is APIOrganizationSearchResult {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('score' in value) || value['score'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function APIOrganizationSearchResultFromJSON(json: any): APIOrganizationSearchResult {
    return APIOrganizationSearchResultFromJSONTyped(json, false);
}

export function APIOrganizationSearchResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIOrganizationSearchResult {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'score': json['score'],
        'name': json['name'],
        'vatNumber': json['vat_number'] == null ? undefined : json['vat_number'],
        'website': json['website'] == null ? undefined : json['website'],
        'rootAccount': json['root_account'] == null ? undefined : APIRootAccountFromJSON(json['root_account']),
        'rootAccountId': json['root_account_id'] == null ? undefined : json['root_account_id'],
        'billingAddress': json['billing_address'] == null ? undefined : APISimpleAddressFromJSON(json['billing_address']),
        'shippingAddress': json['shipping_address'] == null ? undefined : APISimpleAddressFromJSON(json['shipping_address']),
    };
}

export function APIOrganizationSearchResultToJSON(value?: APIOrganizationSearchResult | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'score': value['score'],
        'name': value['name'],
        'vat_number': value['vatNumber'],
        'website': value['website'],
        'root_account': APIRootAccountToJSON(value['rootAccount']),
        'root_account_id': value['rootAccountId'],
        'billing_address': APISimpleAddressToJSON(value['billingAddress']),
        'shipping_address': APISimpleAddressToJSON(value['shippingAddress']),
    };
}

